import { render, staticRenderFns } from "./DataOrder.vue?vue&type=template&id=592891e0&scoped=true&"
import script from "./DataOrder.vue?vue&type=script&lang=js&"
export * from "./DataOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592891e0",
  null
  
)

export default component.exports